export default __webpack_public_path__ + "static/media/valentines.d66560cb.png";